import StarRating from './starRating'

export default StarRating
